import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { news } from "@/mocks/news";

export default function NewsLatest() {
  const sorted = [...news].sort((a, b) => (a.date < b.date ? 1 : -1));
  const [lead, ...rest] = sorted;
  const list = rest.slice(0, 5);

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100/60">
      <SectionHeading
        kicker="最新动态"
        title="杨幂最新动态与新闻"
        desc="活动、访谈、花絮与作品动态，时间倒序更新。"
        morePath="/news"
      />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
        <Link
          to={`/news/${lead.id}`}
          className="group block bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors"
        >
          <div className="relative w-full aspect-[16/9] overflow-hidden bg-background-100">
            <img
              src={lead.cover}
              alt={`${lead.title}配图`}
              title={`${lead.title} - 杨幂动态`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md text-xs font-label bg-accent-500 text-primary-950">
              {lead.category}
            </span>
          </div>
          <div className="p-5 md:p-6">
            <span className="text-xs text-foreground-400">{lead.date}</span>
            <h3 className="mt-2 font-heading text-lg md:text-2xl font-bold text-foreground-950 group-hover:text-primary-600 transition-colors leading-snug">
              {lead.title}
            </h3>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed line-clamp-2">{lead.summary}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-sm font-label text-primary-600">
              阅读全文 <i className="ri-arrow-right-line" />
            </span>
          </div>
        </Link>

        <div className="flex flex-col divide-y divide-background-200 bg-background-50 border border-background-200 rounded-lg overflow-hidden">
          {list.map((item) => (
            <Link
              key={item.id}
              to={`/news/${item.id}`}
              className="group flex items-start gap-4 p-4 md:p-5 hover:bg-background-100/70 transition-colors"
            >
              <span className="font-heading text-2xl font-bold text-background-300 group-hover:text-primary-300 transition-colors leading-none mt-1">
                {item.date.slice(5).replace("-", "/")}
              </span>
              <div className="min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="px-2 py-0.5 rounded-md text-[11px] font-label bg-secondary-100 text-secondary-900">
                    {item.category}
                  </span>
                </div>
                <h4 className="font-heading text-sm md:text-base font-semibold text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h4>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}